export default __webpack_public_path__ + "static/extensions-be4ba6b02d895029714bf5d4b77a4719.png";